// eslint-disable-next-line no-unused-vars
import uPlot from "uplot";
import { parseJsonOrDefault } from "../../utils/parseJsonOrDefault";

// Observer changes to data and preset
export function dataSync($chart) {
  let observer = null;

  function handleDataUpdate(uplot) {
    const data = parseJsonOrDefault($chart.dataset.data, []);

    // setData will also redraw
    uplot.setData(data, true);
  }

  function handleUnitUpdate(uplot) {
    const unit = $chart.dataset.unit;
    if (uplot.hooks.setUnit) {
      uplot.hooks.setUnit.forEach((fn) => fn(uplot, unit));
    }
  }

  function handleSelectedUpdate(uplot) {
    const selected = parseInt($chart.dataset.selected);
    if (uplot.hooks.setSelected) {
      uplot.hooks.setSelected.forEach((fn) => fn(uplot, selected));
    }
  }

  function init(uplot) {
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        switch (mutation.attributeName) {
          case "data-data":
            return handleDataUpdate(uplot);
          case "data-unit":
            return handleUnitUpdate(uplot);
          case "data-selected":
            return handleSelectedUpdate(uplot);
        }
      });
    });

    observer.observe($chart, {
      attributes: true,
      attributeFilter: ["data-data", "data-unit", "data-selected"],
    });
  }

  function destroy() {
    if (observer) {
      observer.disconnect();
    }
  }

  return {
    hooks: {
      init,
      destroy,
    },
  };
}
